<template>
  <div class="commerce-page" v-if="business && commerce" :key="$route.fullPath">
    <MainBackButton />

    <div class="top-bar" :style="themeBgColor">
      <p :style="themeColor">
        {{ pageName }}
        <!-- <span class="favorite">
          <i v-if="true" class="far fa-star fa-sm" />
          <i v-else class="fa fa-star fa-sm" />
        </span> -->
      </p>
    </div>

    <div class="body no-scrollbar">
      <CommercePageExamplesTutorials
        v-if="page === 'examples-and-tutorials'"
        :b="b"
      />

      <CommercePageBusinessInfo v-if="page === 'business-info'" :b="b" />
      <CommercePageShopAppearance v-if="page === 'shop-appearance'" :b="b" />
      <CommercePageMenuProductList v-if="page === 'menu-product-list'" :b="b" />
      <CommercePagePromotionsMarketing
        v-if="page === 'promotions-and-marketing'"
      />
      <CommercePageMembersLoyalty
        v-if="page === 'members-and-loyalty'"
        :b="b"
      />
      <CommercePageLinksAssets
        v-if="page === 'links-qr-codes-and-assets'"
        :b="b"
      />
      <CommercePageStaff v-if="page === 'staff'" :b="b" />
      <CommercePageFulfilmentOptions
        v-if="page === 'fulfilment-options'"
        :b="b"
      />
      <CommercePagePaymentOptions v-if="page === 'payment-options'" :b="b" />
      <CommercePageTukExpress v-if="page === 'tuk-express'" :b="b" />
      <CommercePageAnalytics v-if="page === 'analytics'" :b="b" />
      <!-- <CommercePageCustomApp v-if="page === 'custom-app-and-whitelabel'" /> -->
      <CommercePageCustomApp v-if="page === 'apps-and-platforms'" :b="b" />
      <CommercePageBilling v-if="page === 'billing'" :b="b" />
      <CommercePageInvoices v-if="page === 'invoices'" :b="b" />
      <CommercePageHelpFAQ v-if="page === 'help-and-faq'" :b="b" />
      <CommercePageSupport v-if="page === 'tuk-support'" :b="b" />
      <CommercePageSuperuser v-if="page === 'superuser'" :b="b" />
      <!-- <div style="height: 100px" /> -->

      <!-- Sub Actions -->
      <CPSetLanguages v-if="page === 'set-languages'" :b="b" />
      <CPSetShopName v-if="page === 'set-shop-name'" :b="b" />
      <CPSetHandle v-if="page === 'set-handle'" :b="b" />
      <CPSetAddress v-if="page === 'set-address'" :b="b" />
      <CPSetPhoneNumber v-if="page === 'set-phone-number'" :b="b" />
      <CPSetBillingInfo v-if="page === 'set-billing-info'" :b="b" />
      <CPSetEmail v-if="page === 'set-email'" :b="b" />
      <CPSetWebsite v-if="page === 'set-website'" :b="b" />
      <CPSetCategories v-if="page === 'set-categories'" :b="b" />
      <CPSetReviewSites v-if="page === 'set-review-sites'" :b="b" />
      <CPSetHours v-if="page === 'set-hours'" :b="b" />
      <CPSetBannerImage v-if="page === 'set-banner-image'" :b="b" />
      <CPSetProfilePic v-if="page === 'set-profile-pic'" :b="b" />
      <CPSetIcons v-if="page === 'set-icons'" />
      <CPSetShopStyle v-if="page === 'set-shop-style'" :b="b" />
      <CPSetMenuPreface v-if="page === 'set-menu-preface'" :b="b" />
      <CPSetThemeColor
        v-if="page === 'set-theme-color'"
        @preview="triggerTempColor"
        :b="b"
      />
      <CPSetChatSocial v-if="page === 'set-chat-and-social'" :b="b" />
      <CPSetCommerceAgentMessage
        v-if="page === 'set-commerce-agent-message'"
        :b="b"
      />
      <CPChangeShop v-if="page === 'change-shop'" :b="b" />
      <CPChangeShopSuperuser v-if="page === 'change-shop-superuser'" :b="b" />
      <CPGoLive v-if="page === 'go-live'" :b="b" />
      <CPYourApps v-if="page === 'your-apps'" :b="b" />
      <CPPlatforms v-if="page === 'platforms'" :b="b" />
      <CPCustomerApp v-if="page === 'customer-app'" :b="b" />
      <CPShopManagerApp v-if="page === 'shop-manager-app'" :b="b" />
      <CPCommerceAgentApp v-if="page === 'commerce-agent-app'" :b="b" />
      <CPDeliveryDriverApp v-if="page === 'delivery-driver-app'" :b="b" />
      <CPSetAppIcon v-if="page === 'set-app-icon'" :b="b" />
      <CPOrderHistory v-if="page === 'order-history'" :b="b" />
    </div>
  </div>
</template>

<script>
import MainBackButton from "@/components/MainBackButton";

// Pages
import CommercePageExamplesTutorials from "@/components/CommercePageExamplesTutorials.vue";
import CommercePageBusinessInfo from "@/components/CommercePageBusinessInfo.vue";
import CommercePageShopAppearance from "@/components/CommercePageShopAppearance.vue";
import CommercePageMenuProductList from "@/components/CommercePageMenuProductList.vue";
import CommercePagePromotionsMarketing from "@/components/CommercePagePromotionsMarketing.vue";
import CommercePageMembersLoyalty from "@/components/CommercePageMembersLoyalty.vue";
import CommercePageLinksAssets from "@/components/CommercePageLinksAssets.vue";
import CommercePageStaff from "@/components/CommercePageStaff.vue";
import CommercePageFulfilmentOptions from "@/components/CommercePageFulfilmentOptions.vue";
import CommercePagePaymentOptions from "@/components/CommercePagePaymentOptions.vue";
import CommercePageTukExpress from "@/components/CommercePageTukExpress.vue";
import CommercePageAnalytics from "@/components/CommercePageAnalytics.vue";
import CommercePageCustomApp from "@/components/CommercePageCustomApp.vue";
import CommercePageBilling from "@/components/CommercePageBilling.vue";
import CommercePageHelpFAQ from "@/components/CommercePageHelpFAQ.vue";
import CommercePageSupport from "@/components/CommercePageSupport.vue";
import CommercePageSuperuser from "@/components/CommercePageSuperuser.vue";
import CommercePageInvoices from "@/components/CommercePageInvoices.vue";

// Actions
import CPSetLanguages from "@/components/CPSetLanguages.vue";
import CPSetShopName from "@/components/CPSetShopName.vue";
import CPSetAddress from "@/components/CPSetAddress.vue";
import CPSetPhoneNumber from "@/components/CPSetPhoneNumber.vue";
import CPSetEmail from "@/components/CPSetEmail.vue";
import CPSetWebsite from "@/components/CPSetWebsite.vue";
import CPSetCategories from "@/components/CPSetCategories.vue";
import CPSetReviewSites from "@/components/CPSetReviewSites.vue";
import CPSetHours from "@/components/CPSetHours.vue";
import CPSetBannerImage from "@/components/CPSetBannerImage.vue";
import CPSetProfilePic from "@/components/CPSetProfilePic.vue";
import CPSetIcons from "@/components/CPSetIcons.vue";
import CPSetMenuPreface from "@/components/CPSetMenuPreface.vue";
import CPSetShopStyle from "@/components/CPSetShopStyle.vue";
import CPSetThemeColor from "@/components/CPSetThemeColor.vue";
import CPSetChatSocial from "@/components/CPSetChatSocial.vue";
import CPSetCommerceAgentMessage from "@/components/CPSetCommerceAgentMessage.vue";
import CPChangeShop from "@/components/CPChangeShop.vue";
import CPChangeShopSuperuser from "@/components/CPChangeShopSuperuser.vue";
import CPGoLive from "@/components/CPGoLive.vue";
import CPSetHandle from "@/components/CPSetHandle.vue";
import CPYourApps from "@/components/CPYourApps.vue";
import CPCustomerApp from "@/components/CPCustomerApp.vue";
import CPShopManagerApp from "@/components/CPShopManagerApp.vue";
import CPCommerceAgentApp from "@/components/CPCommerceAgentApp.vue";
import CPDeliveryDriverApp from "@/components/CPDeliveryDriverApp.vue";
import CPSetAppIcon from "@/components/CPSetAppIcon.vue";
import CPPlatforms from "@/components/CPPlatforms.vue";
import CPSetBillingInfo from "@/components/CPSetBillingInfo.vue";
import CPOrderHistory from "@/components/CPOrderHistory.vue";

export default {
  name: "CommercePage",
  components: {
    MainBackButton,
    CommercePageExamplesTutorials,
    CommercePageBusinessInfo,
    CommercePageShopAppearance,
    CommercePageMenuProductList,
    CommercePagePromotionsMarketing,
    CommercePageMembersLoyalty,
    CommercePageLinksAssets,
    CommercePageStaff,
    CommercePageFulfilmentOptions,
    CommercePagePaymentOptions,
    CommercePageTukExpress,
    CommercePageAnalytics,
    CommercePageCustomApp,
    CommercePageBilling,
    CommercePageInvoices,
    CommercePageHelpFAQ,
    CommercePageSupport,
    CommercePageSuperuser,
    // Actions
    // CPSetLanguages: () => import("@/components/CPSetLanguages.vue"),
    CPSetLanguages,
    CPSetShopName,
    CPSetAddress,
    CPSetPhoneNumber,
    CPSetEmail,
    CPSetWebsite,
    CPSetCategories,
    CPSetReviewSites,
    CPSetHours,
    CPSetBannerImage,
    CPSetProfilePic,
    CPSetMenuPreface,
    CPSetShopStyle,
    CPSetThemeColor,
    CPChangeShop,
    CPChangeShopSuperuser,
    CPSetIcons,
    CPSetChatSocial,
    CPSetCommerceAgentMessage,
    CPGoLive,
    CPSetHandle,
    CPYourApps,
    CPCustomerApp,
    CPShopManagerApp,
    CPCommerceAgentApp,
    CPDeliveryDriverApp,
    CPSetAppIcon,
    CPPlatforms,
    CPSetBillingInfo,
    CPOrderHistory,
  },
  props: {
    page: String,
  },
  data() {
    return {
      business: null, // fix caching issue
      tempColor: null, // temporary preview color
    };
  },
  // watch: {
  //   fullPath() {
  //     this.refreshBusiness();
  //     console.log("path changed");
  //   },
  // },
  computed: {
    b() {
      return this.business;
    },
    fullPath() {
      return this.$route.fullPath;
    },
    // business() {
    //   return this.$store.state.selectedBusiness;
    // },
    roleBusinessID() {
      if (!this.$store.getters.getCommerceAgentRole) return null;
      return this.$store.getters.getCommerceAgentRole.business.id;
    },
    data() {
      return this.business.data;
    },
    commerce() {
      if (!this.business || !this.business.workflows) return null;
      return this.business.workflows.find((w) => w.name === "Commerce");
    },
    pageName() {
      return this.$t(`commerce-page-name.${this.page}`);
    },
    themeBgColor() {
      if (this.tempColor) {
        return `background-color: ${this.tempColor}`;
      }
      var bgColor = this.business.data.theme_color;
      if (!bgColor) return null;
      return `background-color: ${bgColor}`;
    },
    themeColor() {
      if (this.tempColor) {
        return `color: ${this.$h.textColor(this.tempColor)}`;
      }
      var bgColor = this.business.data.theme_color;
      if (!bgColor) return null;
      return `color: ${this.$h.textColor(bgColor)}`;
    },
  },
  activated() {
    this.update();
  }, // not in KeepAlive
  mounted() {
    console.log("CommercePage mounted");
    this.update();
  },
  methods: {
    triggerTempColor(color) {
      this.tempColor = color;
      setTimeout(() => (this.tempColor = null), 5000);
    },
    update() {
      var roles = this.$store.state.roles;
      if (roles) {
        var id = this.roleBusinessID;
        if (this.$store.state.selectedBusiness) {
          id = this.$store.state.selectedBusiness.id;
        }
        // id could be null...
        var valid = roles.find(
          (r) => r.role_name === "Commerce Agent" && r.business_id === id
        );
        if (valid || this.isSuperUser()) {
          this.refreshBusiness(id);
          return; // allowed
        }
      }
      this.infoToast("Login to view this page", "top", 9000);
      this.goHome();
      // this.goto(`/commerce_home/${this.roleBusinessID}`); // go to the right biz id
    },
    refreshBusiness(id) {
      var businessID = id || this.roleBusinessID;
      this.$store
        .dispatch("getAndSelectBusiness", businessID)
        .then((res) => {
          console.log("refreshBusiness", res.data);
          if (!this.business) {
            this.business = res.data;
          } else if (this.businessUpdated(res.data)) {
            this.business = null;
            this.$nextTick(() => (this.business = res.data));
          }
          // this.business = null;
          // this.$nextTick(() => (this.business = res.data));
        })
        .catch((err) => this.apiError(err));
      // used to call .dispatch("getWorkflows", this.roleBusinessID)... not necessary
    },
    businessUpdated(b) {
      if (this.business.updated_at !== b.updated_at) return true;
      var c = b.workflows.find((w) => w.name === "Commerce");
      if (c && this.commerce.updated_at !== c.updated_at) return true;
      return false;
    },
  },
};
</script>


<style scoped>
.commerce-page {
  height: 100vh;
  overflow: hidden;
  text-align: left;
  max-width: 600px;
  /* margin: auto; */
}
.top-bar {
  position: absolute;
  top: 0;
  height: 56px;
  width: 100vw;
  max-width: 600px;

  background-color: rgb(59, 59, 59);
  z-index: 1;
}
.top-bar p {
  margin-left: 60px;
  margin-right: 12px;
  margin-top: 15px;
  font-size: 1.1em;
  font-weight: 500;
  /* max-width: calc(100vw - 108px); */
  color: lightgoldenrodyellow;
  white-space: nowrap;
  overflow: auto;
}
.favorite {
  float: right;
  opacity: 0.4;
}
.body {
  height: calc(100vh - 56px);
  margin-top: 56px;
  overflow: auto;
}
</style>